import _objectSpread from "/Users/dfravel/Projects/degreedata-wp/wp-content/plugins/dd-search/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
// Styles
import "../../../src/components/VList/VListItemGroup.sass"; // Extensions

import { BaseItemGroup } from '../VItemGroup/VItemGroup'; // Mixins

import Colorable from '../../mixins/colorable'; // Utilities

import mixins from '../../util/mixins';
export default mixins(BaseItemGroup, Colorable).extend({
  name: 'v-list-item-group',
  provide: function provide() {
    return {
      isInGroup: true,
      listItemGroup: this
    };
  },
  computed: {
    classes: function classes() {
      return _objectSpread({}, BaseItemGroup.options.computed.classes.call(this), {
        'v-list-item-group': true
      });
    }
  },
  methods: {
    genData: function genData() {
      return this.setTextColor(this.color, _objectSpread({}, BaseItemGroup.options.methods.genData.call(this), {
        attrs: {
          role: 'listbox'
        }
      }));
    }
  }
});